import { Plugin } from '@ckeditor/ckeditor5-core';
import insertRocAsset from '../theme/icons/insertRocasset.svg';
import assetResize from '../theme/icons/assetResize.svg';
import { ButtonView } from '@ckeditor/ckeditor5-ui';
import '../theme/css/style.css';
import RefreshRocAssetsCommand from "./refreshassetcommand";

export default class InsertRocAsset extends Plugin {
	static get pluginName() {
		return 'InsertRocAsset';
	}

	static get requires() {
		return ['ImageEditing', 'ImageBlockEditing', 'ImageInlineEditing'];
	}

	init() {
		const editor = this.editor;
		const conversion = editor.conversion;
		const viewDocument = editor.editing.view.document;
		const schema = editor.model.schema;
		const imageUtils = editor.plugins.get('ImageUtils');
		const rocAssetConfig = editor.config.get('rocasset');
		const imageInsert = editor.commands.get('insertImage');
		schema.extend('imageInline', {
			allowAttributes: ['rocasset'],
		});

		conversion
			.for('dataDowncast')
			.add(this._downcastRocAssetAttribute(imageUtils, 'imageInline', 'rocasset', false));
		conversion
			.for('editingDowncast')
			.add(this._downcastRocAssetAttribute(imageUtils, 'imageInline', 'rocasset', true));

		schema.extend('imageBlock', {
			allowAttributes: ['rocasset'],
		});

		conversion
			.for('dataDowncast')
			.add(this._downcastRocAssetAttribute(imageUtils, 'imageBlock', 'rocasset', false));
		conversion
			.for('editingDowncast')
			.add(this._downcastRocAssetAttribute(imageUtils, 'imageBlock', 'rocasset', true));

		conversion.for('upcast').attributeToAttribute({
			view: {
				name: 'img',
				key: 'rocasset',
			},
			model: {
				key: 'rocasset',
				value: (viewElement) => {
					const assetObj = JSON.parse(unescape(viewElement.getAttribute('rocasset')));
					return assetObj;
				},
			},
		});

        editor.commands.add('refreshRocAssets', new RefreshRocAssetsCommand(editor));

		editor.ui.componentFactory.add('insertRocasset', (locale) => {
			const view = new ButtonView(locale);

			view.set({
				label: 'Insert Roc Asset',
				icon: insertRocAsset,
				tooltip: true,
			});
			view.bind('isEnabled').to(imageInsert, 'isEnabled');

			view.on('execute', (evt, data) => {
				if (rocAssetConfig['editAction']) {
					rocAssetConfig.editAction(this._getInitialValuesFromSelection());
				}
			});
			return view;
		});

		this.listenTo(
			viewDocument,
			'click',
			(evt, data) => {
				this.set(
					'isRocAsset',
					!!this._hasRocAssetAttribute(editor.model.document.selection.getSelectedElement()),
				);
			},
			{ priority: 'high' },
		);

		editor.ui.componentFactory.add('setAssetDimensions', (locale) => {
			const view = new ButtonView(locale);
			view.set({
				label: 'Set Roc Dimensions',
				icon: assetResize,
				tooltip: true,
				isOn: true
			});

			view.on('execute', (evt, data) => {
				if (rocAssetConfig['resizeAction']) {
					rocAssetConfig.resizeAction(this._getInitialValuesFromSelection());
				}
			});
			return view;
		});
	}

	_getInitialValuesFromSelection() {
		const selectedElement = this.editor.model.document.selection.getSelectedElement();
		return selectedElement && selectedElement.getAttribute('rocasset')
			? Object.fromEntries(selectedElement.getAttributes())
			: {};
	}

	_hasRocAssetAttribute(selectedElement) {
		return selectedElement && selectedElement.getAttribute('rocasset');
	}

	_downcastRocAssetAttribute(imageUtils, imageType, attributeKey, editing) {
		return (dispatcher) => {
			dispatcher.on(`attribute:${attributeKey}:${imageType}`, converter);
		};

		function converter(evt, data, conversionApi) {
			if (!conversionApi.consumable.consume(data.item, evt.name)) {
				return;
			}

			const viewWriter = conversionApi.writer;
			const element = conversionApi.mapper.toViewElement(data.item);
			const img = imageUtils.findViewImgElement(element);

			viewWriter.setAttribute(data.attributeKey, escape(JSON.stringify(data.attributeNewValue)) || '', img);
			if (editing) {
				if (data.attributeNewValue.dimension && data.attributeNewValue.dimension.width) {
					viewWriter.setStyle(
						{
							width: data.attributeNewValue.dimension.width,
							height: data.attributeNewValue.dimension.height,
						},
						img,
					);
				}
			}
		}
	}
}
